import { MenuItems } from "@/types/menu";

import account from "./account";
import admin from "./admin";
import agentTraffic from "./agent-traffic";
import support from "./support";

// ==============================|| MENU ITEMS ||============================== //

const menuItems: MenuItems = {
  items: [account, agentTraffic, support, admin],
};

export default menuItems;
